// extracted by mini-css-extract-plugin
export var divider = "_fb-7";
export var itemsToggle = "_fb-8";
export var mergeModal = "_fb-1";
export var optionCard = "_fb-4";
export var radioGroup = "_fb-6";
export var radioOption = "_fb-0";
export var selected = "_fb-5";
export var shipmentOptions = "_fb-2";
export var tableOptions = "_fb-3";